let navItems = {
  default: [
  { title: 'Accueil',
    icon: 'mdi-home',
    goTo: '/',
  },
  { title: 'LeaTV',
    icon: 'mdi-video',
    goTo: '/tv',
  },
  { title: 'LeaPhotos',
    icon: 'mdi-image',
    goTo: '/photos',
  },
  // { title: 'Nos projets',
  //   icon: 'mdi-movie-open',
  //   goTo: '/projects',
  // }
],
admin: [
  { title: 'Console',
    icon: 'mdi-security',
    goTo: '/admin',
  },
]
}

export default navItems